import React, { useState, useEffect, useRef } from 'react';
import Input from '../../../../Components/Input';
import Dropdown from '../../../../Components/Dropdown';
import Loader from '../../../../Components/Loader';
import UserDeviceIdController from '../../../Controllers/AdminScreens/Users/UserDeviceIdController';

const UserDeviceIdScreen = ({ isUserEditable, userInfo, loading, error, onRefresh }) => {
    const {
        handleUpdateDevice,
        handleCancel,
        deviceTypes,
        deviceData,
        handleDeviceChange,
        handleInputChange,
        updateLoading,setDeviceIdError,
        deviceUpdateSuccess,setDeviceTypeError,
        deviceUpdateError, deviceIdError, copied,deviceTypeError,
        handleGenerateDeviceId, generatedDeviceId, handleCopyToClipboard
    } = UserDeviceIdController(userInfo, onRefresh);
    const dropdownRefs = useRef({}); // Ref for dropdown
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    // Validate Device ID
    // const validateDeviceID = (id) => {
    //     const regex = /^[a-zA-Z0-9]{1,20}$/; // Match alphanumeric IDs of up to 20 characters
    //     return regex.test(id);
    // };

    const handleDeviceIdChange = (e) => {
        const value = e.target.value;
        handleInputChange('device_id', value);
        setDeviceIdError('')
        // // Validate Device ID
        // if (!validateDeviceID(value)) {
        //     setDeviceIdError('Device ID is not valid. It should be alphanumeric and max 20 characters long.');
        // } else {
        //     setDeviceIdError('');
        // }
    };

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="user-device-id-screen">
            <div>
                <h2 className='basic-info-header'>Manage Device ID</h2>
            </div>


            {/* Device ID Input Section */}
            {
                !isUserEditable ? (
                    <div className='form-grid'>

                        <div className="basic-info-item">
                            <span className="basic-info-label">Device Type</span>
                            <span className="basic-info-value">
                                {deviceData?.device_type?.label || '--'}
                            </span>

                        </div>
                        <div className="basic-info-item">

                            <span className="basic-info-label">Device Name</span>
                            <span className="basic-info-value">
                                {deviceData?.device_name || '--'}
                            </span>
                        </div>
                        <div className="basic-info-item">

                            <span className="basic-info-label">Device ID</span>
                            <span className="basic-info-value">
                                {deviceData.device_id || '--'}
                            </span>
                        </div>
                    </div>
                ) :
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                        <Dropdown
                            ref={(el) => (dropdownRefs.current["groupName"] = el)}
                            isOpen={openDropdown === "groupName"}
                            toggleDropdown={() => toggleDropdown("groupName")}
                            label="Device Type"
                            options={[
                                { label: "Personal", value: "Personal" },
                                { label: "Company", value: "Company" },
                                { label: "Mobile", value: "Mobile" },
                            ]}
                            value={deviceData?.device_type?.label}
                            onChange={(value) =>{ handleDeviceChange('device_type', value);setDeviceTypeError('')}}
                            searchBoxWidth={200}
                            disabled={!isUserEditable}
                            errorMessage={deviceTypeError}
                        />
                        <Input
                            label="Device Name "
                            placeholder='Enter device name'
                            value={deviceData?.device_name || ''}
                            onChange={(e) => handleInputChange('device_name', e.target.value)}
                            maxLength={20}
                            searchBoxWidth={200}
                            isEdit={isUserEditable}
                        />

                        <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                            <Input
                                label="Device ID"
                                placeholder='Enter device id'
                                value={deviceData.device_id || ''}
                                onChange={handleDeviceIdChange}
                                errorMessage={deviceIdError}
                                searchBoxWidth={290}
                                isEdit={isUserEditable}
                            />
                            {isUserEditable &&
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10,paddingTop: deviceIdError ? 0:15 }}>
                                    <button onClick={handleGenerateDeviceId} className="add-client-button">
                                        Generate Device ID
                                    </button>
                                </div>
                            }
                        </div>


                    </div>

            }
            {generatedDeviceId && (
                <div style={{ marginTop: 8, padding: '8px 12px', background: '#e6f4ea', borderLeft: '4px solid #34a853', color: '#2e7d32', fontSize: 14 }}>
                    Device ID generated and stored successfully.<br />
                    Use this browser/device only to log in. Other devices will be blocked.<br />
                    {generatedDeviceId && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <span style={{ fontStyle: 'italic', fontSize: 14, color: '#555' }}>
                                <span style={{ color: '#2e7d32' }}>  Generated ID:</span> <code>{generatedDeviceId}</code>
                            </span>
                            <button
                                onClick={handleCopyToClipboard}
                                style={{
                                    padding: '4px 8px',
                                    fontSize: 12,
                                    cursor: 'pointer',
                                    background: '#048408',
                                    border: 'none',
                                    borderRadius: 4,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4,
                                    color:'#FFFFFF'
                                }}
                            >
                                {copied ? 'Copied' : 'Copy'}
                                {/* {copied && <span style={{ color: 'green' }}>✅</span>} */}
                            </button>
                        </div>
                    )}
                </div>
            )}
            {/* Buttons */}
            {isUserEditable &&
                <div className="button-container" style={{ gap: 20, flexWrap: 'wrap' }}>
                    <button
                        onClick={handleUpdateDevice}
                        disabled={updateLoading}
                        className="add-client-button"
                        style={{ opacity: updateLoading ? 0.5 : 1, cursor: updateLoading ? 'not-allowed' : 'pointer' }}
                    >
                        {updateLoading && <span style={{ paddingRight: 5 }}> <Loader loading={updateLoading} color={'var(--background-color)'} size='small' /> </span>}Update Device
                    </button>
                    <button onClick={handleCancel} className="cancel-button">Cancel</button>
                    {deviceUpdateError && <div className="list-error-msg">{deviceUpdateError}</div>}
                    {deviceUpdateSuccess && <div className="list-success-msg">{deviceUpdateSuccess}</div>}

                </div>
            }
        </div>
    );
};

export default UserDeviceIdScreen;
